import React from 'react';
import theme from './ResidentialUnitEdit.module.scss';
import { Trans } from '@lingui/react/macro';
import { Order } from '@/types';
import Banner from '@/components/Banner';
import OrderListItem from '@/seller/components/orders/OrderListItem';

interface ResidentialUnitTagsOrdersProps {
    orders: Order[];
}

const ResidentialUnitTagsOrders: React.FC<ResidentialUnitTagsOrdersProps> = ({ orders }) => {
    return (
        <>
            <Banner type="info">
                <Trans>
                    <strong>Please note</strong> below are the orders connected to the buyer options that will be removed. By
                    removing the options, you will also cancel these orders.
                </Trans>
            </Banner>
            <div className={theme.subHeader}>Orders connected to the tags</div>
            <div className={theme.listWrapper}>
                {orders?.map((o) => (
                    <OrderListItem key={o.id} onChange={() => null} order={o} readOnly />
                ))}
            </div>
        </>
    );
};

export default ResidentialUnitTagsOrders;
